var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('publicHead'),(_vm.isRouterAlive)?_c('router-view',{key:_vm.$route.fullPath,staticClass:"appCont"}):_vm._e(),_c('publicFoot',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.footShow),expression:"$route.meta.footShow"}],ref:"usernameInput"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }